<template>
    <div class="titleBar">
        <div class="title_center">
            <div class="left_title">
                <div class="icon_left">
                    <img src="../assets/xiangning/home/bar_logo_left.png" alt="">
                </div>
                <div class="content_right">
                    <div class="content_right_top">
                    </div>
                    <div class="sx_titie">
                        {{ titleName }}
                        <img src="../assets/xiangning/home/title_star.png" alt="">
                    </div>
                </div>
            </div>
            <div class="getMore" @click="goNews">
                <span>查看更多 </span>
                <div class="getMore_icon">
                    <img src="../assets/xiangning/home/getMore.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        titleName: {
            type: String,
            default: '新闻中心'
        },

    },

    computed: {

    },
    methods: {
        goNews() {
            let that = this
            that.$emit('goDetail');
        }
    }
}
</script>

<style lang="scss" scoped>
.titleBar {
    width: 100%;
    height: 42px;
    display: flex;
    align-items: center;

    .title {
        display: flex;
        background-image: url('../assets/xiangning/home/bar_logo.png');
        width: 159px;
        height: 100%;
        background-size: 100% 100%;
        box-sizing: border-box;
        padding-left: 63px;

        .hot_title {
            // height: 100%;
            // width: 120px;
            line-height: 42px;
            font-family: PingFangSC-Medium;
            font-size: 18px;
            font-weight: normal;
            letter-spacing: 0.1em;

            // background-color: pink;
            .news {
                color: #EE632B
            }

            .newCenter {
                margin-left: 10px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                font-weight: normal;
                letter-spacing: 0em;
                color: #666666;
            }
        }
    }

    .title_center {
        width: 100%;
        height: 32px;
        background: #FFF6F1;
        position: relative;

        .left_title {
            width: 160px;
            height: 42px;
            background-size: 100% 100%;
            position: absolute;
            top: -5px;
            left: 0;
            display: flex;

            .icon_left {
                height: 100%;
                width: 61px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .content_right {
                position: relative;
                width: 100px;
                height: 100%;

                .content_right_top {
                    position: absolute;
                    top: 0;
                    left: -5px;
                    width: 105%;
                    height: 5px;
                    background-color: #D72518;
                    border-radius: 0 20px 0 0;
                }

                .sx_titie {
                    position: absolute;
                    top: 5px;
                    height: 32px;
                    width: 100px;
                    line-height: 32px;
                    font-family: PingFang SC;
                    font-size: 18px;
                    font-weight: 600;
                    letter-spacing: 0em;
                    color: #D31813;
                    display: flex;
                    align-items: center;
                    img{
                        width: 20px;
                        height: 20px;
                        margin-left: 5px;
                    }
                }

            }
        }
    }

    .getMore {
        position: absolute;
        right: 0;
        top: 0;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        font-weight: normal;
        letter-spacing: 0em;
        color: #666666;
        line-height: 32px;
        cursor: pointer;
        .getMore_icon {
            margin-right: 10px;
            margin-left: 10px;
            display: inline-block;
            width: 4px;
            height: 8px;
        }
    }

    .getMore:hover {
        color: #EE632B;
        font-weight: 800;
    }

}</style>
